export default "__VITE_PUBLIC_ASSET__1f9574c1__"